import React from 'react';
import Button from '@mui/material/Button';

interface Props {
    children?: any;
    errorMsg: string;
    history: any;
}

class ErrorBoundary extends React.Component<Props, any> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        console.log(error);
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo);
        // logErrorToMyService(error, errorInfo);
    }

    render() {
        const { history } = this.props;
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <h1>
                    {this.props.errorMsg} - {history.location.pathname}
                    <Button variant="contained" onClick={() => window.location.reload()}>
                        Refresh
                    </Button>
                </h1>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
